import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const dateRangeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (control.value) {
        if (
            control.value.start && control.value.start.isValid()
            && control.value.end && control.value.end.isValid()
            && control.value.start.isSameOrAfter(control.value.end)
        ) {
            return {
                rangeStartAfterEnd: {
                    spsLabelErrorMessage: "The start of a date range cannot be the same as or after its end."
                }
            };
        }
    }
    return null;
};
